import { render, staticRenderFns } from "./Otros.vue?vue&type=template&id=c516d11c&scoped=true"
import script from "./Otros.vue?vue&type=script&lang=js"
export * from "./Otros.vue?vue&type=script&lang=js"
import style0 from "./Otros.vue?vue&type=style&index=0&id=c516d11c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c516d11c",
  null
  
)

export default component.exports